import { qsa } from "@fluorescent/dom";
import {
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal",
  fadeUpSplit: ".animation-fade-up-split-reveal",
};

export default node => {
  let observer = null;
  const fadeUpSplitItems = qsa(selectors.fadeUpSplit, node);
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const textReveals = [];

  if (shouldAnimate(node)) {
    fadeUpSplitItems.forEach(item => {
      textReveals.push(new FadeUpSplitReveal(item));
    });

    fadeUpItems.forEach(item => {
      textReveals.push(new FadeUpReveal(item));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let textDelay = 0;
    textReveals.forEach(reveal => {
      reveal.play(textDelay);

      if (reveal.type === "FadeUpSplitReveal") {
        textDelay += reveal.lineCount * window.theme.animation.delay;
      } else {
        textDelay += window.theme.animation.delay;
      }
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
